export const UPDATE_STATE_WITH_IDS = "UPDATE_STATE_WITH_IDS";
export const UPDATE_ALL_SERVERS_INFO = "UPDATE_ALL_SERVERS_INFO";
export const UPDATE_CURRENT_SERVER_DETAIL = "UPDATE_CURRENT_SERVER_DETAIL";
export const UPDATE_CURRENT_FLIGHT_DETAIL = "UPDATE_CURRENT_FLIGHT_DETAIL";
export const UPDATE_CURRENT_AIRPORT_DETAIL = "UPDATE_CURRENT_AIRPORT_DETAIL";
export const SET_CURRENT_SERVER_BY_ID = "SET_CURRENT_SERVER_BY_ID";
export const SET_CURRENT_FLIGHT_BY_ID = "SET_CURRENT_FLIGHT_BY_ID";
export const SET_CURRENT_AIRPORT_BY_ICAO = "SET_CURRENT_AIRPORT_BY_ICAO";
export const SET_CURRENT_FLIGHT_BY_INDEX = "SET_CURRENT_FLIGHT_BY_INDEX";
export const SET_CURRENT_AIRPORT_BY_INDEX = "SET_CURRENT_AIRPORT_BY_INDEX";
